// Payment.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import CardList from "./CardList";
import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import Loader3Orange from "../../general/Loader3Orange";
import { getBrokerInformation } from "../../store/broker";
import { createCharge, createChargeSuccess } from "../../store/myquotes";
import translations from "../../utils/translations";

const publicKey = process.env.REACT_APP_STRIPE_KEY;
const stripePromise = loadStripe(publicKey);


const Payment = () => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disable, setDisable] = useState(false);
  const broker = useSelector(getBrokerInformation);
  const chargeData = useSelector(createChargeSuccess);

  // Access language preference from Redux store or context

  const languagepreference = broker.information.languagepreference;
  // Accessing brokerageAdmin.payment translations
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;

  useEffect(() => {
    if (chargeData) {
      toast.success(chargeData.message);
    }
  }, [chargeData]);

  const handleYesClick = () => {
    setLoader(true);
    dispatch(createCharge())
      .then(() => {
        setLoader(false);
        setDisable(true);
        setModal(false);
      })
      .catch((error) => {
        setLoader(false);
        // Optionally handle error with a toast or another method
        toast.error("An error occurred while processing your payment."); // Consider translating this
      });
  };

  const handleNoClick = () => {
    setModal(false);
  };

  return (
    <div>
      {broker && broker.information.is_subscribed === false ? (
        <Button
          style={{
            display: "flex",
            color: "white",
            fontFamily: "GibsonRegular",
            fontSize: 12,
            backgroundColor: theme.COLORS.secondary_orange,
            marginLeft: "85%",
            marginTop: "12px",
            border: 0,
            letterSpacing: 1,
          }}
          onClick={() => setModal(true)}
        >
          {translationsBrokerAdmin.subscribeNow}
        </Button>
      ) : null}

      <Modal
        isOpen={modal}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: "27rem",
            width: "40vw",
            position: "absolute",
            top: "7vh",
            left: "30vw",
            right: 0,
            bottom: 0,
            background: theme.COLORS.primary_navyblue,
            border: "8px solid white",
            borderRadius: "30px",
            padding: "4vmin",
          },
        }}
      >
        <div>{loader ? <Loader3Orange /> : null}</div>
        <div>
          <span
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "30px",
              marginLeft: "4%",
            }}
          >
            {translationsBrokerAdmin.paymentConfirmation}
          </span>
          <p
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.1rem",
              display: "flex",
              paddingTop: "4%",
              marginBottom: "4%",
              marginLeft: "4%",
            }}
          >
            {translationsBrokerAdmin.paymentDescription}
          </p>
        </div>
        <div style={{ alignContent: "center", marginLeft: "20%" }}>
          <Button
            disabled={disable}
            style={{
              color: "white",
              height: "4.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 16,
              backgroundColor: theme.COLORS.secondary_orange,
              marginTop: 5,
              marginLeft: 10,
              border: 0,
              width: "9vw",
              letterSpacing: 1,
            }}
            onClick={handleYesClick}
          >
            {translationsBrokerAdmin.yes}
          </Button>
          <Button
            style={{
              color: "white",
              height: "4.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 16,
              backgroundColor: theme.COLORS.secondary_orange,
              marginTop: 5,
              marginLeft: 10,
              border: 0,
              width: "9vw",
              letterSpacing: 1,
            }}
            onClick={handleNoClick}
          >
            {translationsBrokerAdmin.no}
          </Button>
        </div>
      </Modal>

      <div
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "1.5vw",
          color: "rgb(63, 68, 90)",
          display: "flex",
          margin: "auto",
          width: "16%",
        }}
      >
        {translationsBrokerAdmin.addNewCardTitle}
      </div>

      <div
        style={{
          fontFamily: "sans-serif",
          height: "30vh",
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "80%",
            maxWidth: "32rem",
            margin: "auto",
            boxShadow: "4px 4px 84px 20px #adb5bdb3",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <div>
            <Elements stripe={stripePromise}>
              <CheckoutForm />
            </Elements>
          </div>
        </div>
      </div>

      <div className="mb-5">
        <div
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: "1.5vw",
            color: "rgb(63, 68, 90)",
            display: "flex",
            margin: "auto",
            width: "11%",
          }}
        >
          <span>{translationsBrokerAdmin.cardsListTitle}</span>
        </div>
        <CardList />
      </div>
    </div>
  );
};

export default Payment;
